import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Bearer token from localStorage handles auth across origins.
// Cookie-based auth is disabled because CORS wildcard + credentials don't mix.
const api = axios.create({
  baseURL: API,
});

// also attach access_token from localStorage if present (cross-origin cookie fallback)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("access_token");
  if (t && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export default api;
